import { render, staticRenderFns } from "./NetworkSaver.vue?vue&type=template&id=28ec90cf&scoped=true"
import script from "./NetworkSaver.vue?vue&type=script&lang=js"
export * from "./NetworkSaver.vue?vue&type=script&lang=js"
import style0 from "./NetworkSaver.vue?vue&type=style&index=0&id=28ec90cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec90cf",
  null
  
)

export default component.exports